import React, { useState } from 'react';
import { useLocalize } from 'localize-react';
import { JourneyStatusType, IJourney } from '@transferz/fe-models';
import { Card } from '@transferz/fe-component-library/src/components/card/Card';
import { Button } from '@transferz/fe-component-library/src/components/button/Button';
import Typography from '@transferz/fe-component-library/src/components/typography/Typography';
import Phone from '@transferz/fe-component-library/src/components/icons/PhoneIcon';
import PhoneRing from '@transferz/fe-component-library/src/components/icons/PhoneRingIcon';
import Organization from '@transferz/fe-component-library/src/components/icons/OrganizationIcon';
import SandClock from '@transferz/fe-component-library/src/components/icons/SandClock';
import './transferCompanyDetails.scss';

export interface ITransferCompanyDetailsProps {
  journey: IJourney;
}

export const TransferCompanyDetails: React.FC<ITransferCompanyDetailsProps> = ({ journey }) => {
  const { translate } = useLocalize();
  const showInfoText = journey?.status === JourneyStatusType.Pending;
  const collapsed = (
    journey?.status === JourneyStatusType.DriverUnderway
    || journey?.status === JourneyStatusType.DriverArrived
    || journey?.status === JourneyStatusType.Completed
    || journey?.status === JourneyStatusType.CancelledWithCosts
    || journey?.status === JourneyStatusType.CancelledFree
  );
  const isOpen = journey?.status === JourneyStatusType.Confirmed || journey?.status === JourneyStatusType.Planned;
  const [isCollapsed, setIsCollapsed] = useState(collapsed);
  const isFAQCompleted = journey.status === JourneyStatusType.JourneyInProgress
    || journey.status === JourneyStatusType.Completed
    || journey.status === JourneyStatusType.CancelledFree
    || journey.status === JourneyStatusType.CancelledWithCosts;
  const isCompleted = journey.status === JourneyStatusType.Completed;
  return (
    <div className={`transfer-company-details card-wrap ${journey?.driver?.name ? 'driver' : ''} ${isFAQCompleted ? 'faq-completed' : ''} ${isCompleted ? 'completed' : ''}`}>
      <Card
        title={translate('transferCompanyTitle')}
        onCollapse={() => setIsCollapsed(!isCollapsed)}
        collapsed={isCollapsed && !isOpen}
        collapsibleIcon={!showInfoText}
        isGrey={showInfoText}
      >
        {showInfoText
          ? (
            <div className="d-flex mb-24">
              <SandClock />
              <Typography variant="body1">{translate('transferCompanyInfoLater')}</Typography>
            </div>
          )
          : (
            <>
              {journey?.transferCompany?.organization?.name && (
                <div className="d-flex mb-24">
                  <Organization />
                  <Typography variant="body1">
                    {journey?.transferCompany?.organization?.name}
                  </Typography>
                </div>
              )}
              {journey?.fleet?.customerSupportInfo?.phone && (
                <div className="d-flex mb-24">
                  <Phone height="20" />
                  <Typography variant="body1">
                    {journey?.fleet?.customerSupportInfo?.phone}
                  </Typography>
                </div>
              )}
              {journey?.fleet?.customerSupportInfo?.phone && (
                <div className="d-flex">
                  <a href={`tel:${journey?.fleet?.customerSupportInfo?.phone}`} className="call-link">
                    <Button
                      priority="primary"
                      variant="info"
                      label={translate('callTransferCompany')}
                      icon={<PhoneRing />}
                      iconPosition="left"
                    />
                  </a>
                </div>
              )}
            </>
          )
        }
      </Card>
    </div>
  );
};
